import { render } from "./todoCard.vue?vue&type=template&id=5bcdddbb"
import script from "./todoCard.vue?vue&type=script&lang=js"
export * from "./todoCard.vue?vue&type=script&lang=js"

import "./todoCard.vue?vue&type=style&index=0&id=5bcdddbb&lang=scss"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__